import SVRQuestionStatus from './SVRQuestionStatus';

export default SVRQuestionStatus;
